import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find-index.js";
import React from 'react';
import { HelpText } from '@applyboard/crystal-ui';
import { useEventTracker, useTrackViewEvent } from '@applyboard/ui-utils';
import { strings } from "./strings";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function ResultMessage(_ref) {
  var text = _ref.text,
    rule = _ref.rule,
    intent = _ref.intent,
    source = _ref.source,
    result = _ref.result;
  switch (result === null || result === void 0 ? void 0 : result.verificationType) {
    case 'plagiarism':
      return _jsx(PlagiarismResultMessage, {
        intent: intent,
        text: text,
        rule: rule,
        source: source,
        result: result
      });
    default:
      return _jsx(DefaultResultMessage, {
        intent: intent,
        text: text,
        rule: rule
      });
  }
}
export function PlagiarismResultMessage(_ref2) {
  var intent = _ref2.intent,
    source = _ref2.source,
    text = _ref2.text,
    rule = _ref2.rule,
    result = _ref2.result;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var eventData = {
    requirementCategory: source.requirementCategory,
    requirementTemplateId: source.requirementTemplateId,
    requirementInstanceId: source.requirementId,
    file_id: source.attachmentId,
    applicationId: source.applicationId,
    requirementId: source.requirementId,
    attachmentId: source.attachmentId
  };
  var checkFailed = rule === 'check_failure' || rule === 'check_timeout' || !text || !(result !== null && result !== void 0 && result.output);
  useTrackViewEvent({
    event: checkFailed ? strings.events.PLAGIARISM_CHECK_ERROR : strings.events.PLAGIARISM_CHECK_SUCCESS,
    data: eventData
  });
  if (checkFailed) {
    return _jsx(DefaultResultMessage, {
      intent: intent,
      text: strings.plagiarismResultMessages.FAILED_TO_CALL_SERVICE,
      rule: rule
    });
  } else {
    if (!result.output) {
      return null;
    }
    // This will not work if the keywords are followed by non-whitespace however this is not an expected scenario
    var reasonText = text.trim().split(/(\s+)/);
    var replacementIndex = reasonText.findIndex(function (element) {
      return element === 'report' || element === 'document';
    });
    reasonText[replacementIndex] = _jsx("a", {
      href: "https://plagiarismcheck.org/lms/public-report/".concat(result.output.id),
      target: "_blank",
      rel: "noreferrer",
      onClick: function onClick() {
        trackEvent({
          event: strings.events.FOLLOWED_PLAGIARISM_LINK,
          data: eventData
        });
      },
      children: reasonText[replacementIndex]
    });
    return _jsx(DefaultResultMessage, {
      intent: intent,
      text: reasonText,
      rule: rule
    });
  }
}
export function DefaultResultMessage(_ref3) {
  var text = _ref3.text,
    intent = _ref3.intent,
    rule = _ref3.rule;
  return _jsx(HelpText, {
    intent: intent,
    showIcon: true,
    children: _jsx("span", {
      children: text
    })
  }, rule);
}